/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import 'lib/downloadCSV';
import { useReducer } from 'react';
import getCartoMap from 'lib/getCartoMap';
import MetricsContext from './MetricsContext';
import reducer from './reducer';
import InnerPanel from './InnerPanel';

const Component = (props: Object = {}) => {
  const [state, dispatch] = useReducer(reducer, {
    mode: 'READY',
    placeMetrics: [],
    placeMetricsOrder: [],
    mapConfigAnalysisBackup: {},
    tipsDismissed: false,
    selectedMetrics: [],
    dataviewUrls: {},
    cartoError: undefined,
    serverError: undefined,
    geojson: undefined,
    widgetForm: {},
    mapConfig: {},
    tables: [],
    handlers: {},
  });
  const ctxExtension = props.ctx || {};
  const stateExtension = props.state || {};
  const s = { ...state, ...stateExtension };

  // Context can be overridden by props. This is useful
  // as a mechanism for dependency injection during testing.
  const ctx = { state: s, dispatch, getCartoMap, ...ctxExtension };
  return (
    <MetricsContext.Provider value={ctx}>
      <InnerPanel />
    </MetricsContext.Provider>
  );
};

export default Component;
